//获取用户信息
import axiosReq from "@/utils/axios-req";
export const userInfoReq = () => {
    return new Promise((resolve) => {
        const reqConfig = {
            url: "/api/v1/user/getInfo",
            method: "get",
        };
        axiosReq(reqConfig).then(({ data }) => {
            resolve(data);
        });
    });
};

//登录
export const loginReq = (subForm) => {
    return axiosReq({
        url: "/api/v1/login",
        params: subForm,
        method: "post",
    });
};

//退出登录
export const loginOutReq = () => {
    return axiosReq({
        url: "/api/v1/logout",
        method: "post",
    });
};

//signup
export const signUpReq = (subForm) => {
    return axiosReq({
        url: "/api/v1/signup",
        params: subForm,
        method: "post",
    });
};

//forgot-password
export const forgotPasswordReq = (subForm) => {
    return axiosReq({
        url: "/api/v1/forgot-password",
        params: subForm,
        method: "post",
    });
};

//reset-password
export const resetPasswordReq = (subForm) => {
    return axiosReq({
        url: "/api/v1/reset-password",
        params: subForm,
        method: "post",
    });
};

//resend email verification
export const resendVerificationReq = (subForm) => {
    return axiosReq({
        url: "/api/v1/email/resend",
        params: subForm,
        method: "post",
    });
};